import { GUID } from "app/common/brightserve-common.module";

export class Param {
	Id: GUID;
	AssociatedValue: string;
	Entity: string;
	Field: string;
	Value: string;
	Definition: string;
	Weighting: number;

	constructor(init?: Partial<Param>) {
		this.Id = GUID.newGuid();
		Object.assign(this, init);
	};
}



// WEBPACK FOOTER //
// ./src/app/common/param.ts